// src/components/Sections.jsx
import React from "react";

const sections = [
    {
        id: "world",
        title: "Explore the World",
        description:
            "Develop cities, construct buildings, gather resources, and explore dungeons. Build the economic foundation your alliance needs to compete.",
        linkText: "Discover the World",
        link: "/world",
    },
    {
        id: "armies-warfare",
        title: "Armies & Warfare",
        description:
            "Choose which troops to recruit, when to raid, and how to attack or defend. Every military decision has an economic cost, and every battle affects your alliance's strategy.",
        linkText: "Explore Armies & Warfare",
        link: "/armies-warfare",
    },
    {
        id: "economy-strategy",
        title: "Economy & Strategy",
        description:
            "Balance resource production, military spending, raiding, trading, and artifact purchases. Coordinate with your alliance to turn sound economic decisions into a competitive advantage.",
        linkText: "Master the Economy",
        link: "/economy-strategy",
    },
    {
        id: "progression-discovery",
        title: "Progression & Discovery",
        description:
            "Discover artifacts, pursue research, earn titles, and develop your strategic options. Choose investments that strengthen your position in the long game.",
        linkText: "Explore Progression",
        link: "/progression-discovery",
    },
    {
        id: "shrines-victory",
        title: "Eight Shrines. One Victory.",
        description:
            "Your alliance must build and defend a level 10 shrine of each of the eight shrine types. Protect your shrines from destruction and stop rival alliances from completing their own set. Hold all eight to win.",
        linkText: "Discover the Path to Victory",
        link: "/shrines-victory",
    },
];

const Sections = () => {
    return (
        <div className="sections">
            {sections.map((section, index) => (
                <section
                    key={section.id}
                    id={section.id}
                    className={`section section-${section.id}`}
                >
                    <div className="section-content">
                        <span className="section-number">
                            {String(index + 1).padStart(2, "0")}
                        </span>

                        <h2>{section.title}</h2>
                        <p>{section.description}</p>

                        <a href={section.link} className="section-link">
                            {section.linkText}
                        </a>
                    </div>
                </section>
            ))}
        </div>
    );
};

export default Sections;